<script setup>
import { computed } from 'vue';
import { Checkbox } from 'dashboard/components-next/polaris/ui/checkbox';
import { ALERT_EVENTS, EVENT_TYPES } from './constants';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update']);

const alertEvents = ALERT_EVENTS;
const alertEventValues = Object.values(EVENT_TYPES);

const selectedValue = computed({
  get: () => {
    // maintain backward compatibility
    if (props.value === 'none') return [];
    if (props.value === 'mine') return [EVENT_TYPES.ASSIGNED];
    if (props.value === 'all') return [...alertEventValues];

    const validValues = props.value
      .split('+')
      .filter(value => alertEventValues.includes(value));

    return [...new Set(validValues)];
  },
  set: value => {
    const sortedValues = value.filter(Boolean).sort();
    const uniqueValues = [...new Set(sortedValues)];

    if (uniqueValues.length === 0) {
      emit('update', 'none');
      return;
    }

    emit('update', uniqueValues.join('+'));
  },
});

const setValue = (isChecked, value) => {
  let updatedValue = selectedValue.value;
  if (isChecked) {
    updatedValue.push(value);
  } else {
    updatedValue = updatedValue.filter(item => item !== value);
  }

  selectedValue.value = updatedValue;
};

const alertDescription = computed(() => {
  const base =
    'PROFILE_SETTINGS.FORM.AUDIO_NOTIFICATIONS_SECTION.ALERT_COMBINATIONS.';

  if (props.value === '' || props.value === 'none') {
    return base + 'NONE';
  }

  return base + selectedValue.value.join('+').toUpperCase();
});
</script>

<!-- Phase 9.5: the kit's checkboxes; same values and the same summary sentence under them. -->
<template>
  <fieldset class="m-0 grid gap-3 border-0 p-0">
    <legend class="mb-1 type-polaris-label">{{ label }}</legend>
    <label
      v-for="option in alertEvents"
      :key="option.value"
      :for="`checkbox-${option.value}`"
      class="flex cursor-pointer items-center gap-3 type-polaris-body"
    >
      <Checkbox
        :id="`checkbox-${option.value}`"
        :model-value="selectedValue.includes(option.value)"
        @update:model-value="isChecked => setValue(isChecked, option.value)"
      />
      {{
        $t(
          `PROFILE_SETTINGS.FORM.AUDIO_NOTIFICATIONS_SECTION.ALERT_TYPES.${option.label.toUpperCase()}`
        )
      }}
    </label>
    <p class="type-polaris-caption text-polaris-muted-foreground">
      {{ $t(alertDescription) }}
    </p>
  </fieldset>
</template>
